import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useHistory, useLocation } from "react-router";
import Table from '@mui/material/Table';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import TextField from '@mui/material/TextField';
import { useAxiosLoader } from '../../../plugins/axios'
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import HeaderTags from '../common/headerTags';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import { visuallyHidden } from '@mui/utils';
import Stack from '@mui/material/Stack'
import LinearProgress from '@mui/material/LinearProgress';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';
import { cleverTap, exportData, isInsurerAdmin } from '../../../services/insurance/common';
import { STATUS_CODE_MAP, SLA_FILTERS, CLEVER_TAP_EVENTS } from '../../../constants/insurance/constant';
import DownloadIcon from '@mui/icons-material/Download';
import ShowCommunicationHistory from "../dialogs/communication-history";
import DownloadReports from "../dialogs/downloadReports";
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextsmsIcon from '@mui/icons-material/Textsms';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}



// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}



const headCells = [
    {
        id: 'requestid',
        numeric: true,
        disablePadding: false,
        label: 'Request Id / Employee Id',
        align: 'left'
    },
    {
        id: 'customername',
        numeric: true,
        disablePadding: false,
        label: 'Customer Name / Corporate Name',
        align: 'left'
    },
    {
        id: 'corporatename',
        numeric: true,
        disablePadding: false,
        label: 'Email / Contact No.',
        align: 'left'
    },
    {
        id: 'appointmentdetails',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        align: 'left'
    },
    {
        id: 'packagedetails',
        numeric: true,
        disablePadding: false,
        label: 'Package Details',
        align: 'left'
    },
    {
        id: 'appointmentdate',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Date & Time',
        align: 'left'
    },
    {
        id: 'createddate',
        numeric: true,
        disablePadding: false,
        label: 'Created On',
        align: 'left'
    },
    {
        id: 'additionals',
        numeric: true,
        disablePadding: false,
        label: '',
        align: 'right'
    }
];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow
                className="bg-gray-100"
            >
                {/* <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell> */}
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            className="font-bold text-xs"
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

export function SLAFilters(props) {
    const { onClickPriorityCases, onClickTotalCases, slaFilter, totalRows, loading, rows } = props;
    return (
        <div className="w-30-per m-auto">
            <div className="w-full flex text-center text-xs">
                <div className={(slaFilter ? "w-full border border-blue-500 text-gray-900 font-semibold text-center rounded-3xl shadow-inner text-xs cursor-pointer mx-2 h-full" : "w-full border border-gray-200 text-gray-900 font-semibold text-center rounded-3xl shadow-md text-xs cursor-pointer mx-2 h-full")}>
                    <div className="p-2" onClick={onClickPriorityCases}>
                        <span className="mr-2">
                            Priority Cases
                        </span>
                        {
                            !loading && slaFilter && rows && rows.length > 0 &&
                            <span className="text-gray-100 font-semibold rounded-3xl p-1 bg-red-500" style={{ fontSize: '10px' }}>
                                {totalRows > 9 ? totalRows : '0' + totalRows}
                            </span>
                        }
                    </div>
                </div>
                <div className={(!slaFilter ? "w-full border border-blue-500 text-gray-900 font-semibold text-center rounded-3xl shadow-inner text-xs cursor-pointer mx-2 h-full" : "w-full border border-gray-200 text-gray-900 font-semibold text-center rounded-3xl shadow-md text-xs cursor-pointer mx-2 h-full")}>
                    <div className="p-2" onClick={onClickTotalCases}>
                        <span className="mr-2">
                            Total Cases
                        </span>
                        {
                            !loading && !slaFilter && rows && rows.length > 0 &&
                            <span className="text-gray-100 font-semibold rounded-3xl p-1 bg-green-500" style={{ fontSize: '10px' }}>
                                {totalRows > 9 ? totalRows : '0' + totalRows}
                            </span>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

SLAFilters.propTypes = {
    onClickPriorityCases: PropTypes.func,
    onClickTotalCases: PropTypes.func,
    slaFilter: PropTypes.bool.isRequired,
    totalRows: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    rows: PropTypes.array.isRequired,
}


export default function AppointmentConfirmedTable(props) {
    const getInitialData = (type) => {
        let data = JSON.parse(localStorage.getItem("pageTracking"))
        if (data && data[type])
            return data[type];
        return type === "sla" ? false : "";
    }
    const [loading] = useAxiosLoader();
    const history = useHistory();
    const location = useLocation()
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('id');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(props.pageNo);
    const [dense] = React.useState(false);
    const [status, setStatus] = React.useState(props.status);
    const [rowsPerPage] = React.useState(10);
    const [rows, setRows] = React.useState(props.rows);
    const [totalRows, setTotalRows] = React.useState(props.totalRows);
    const [customerAttendance, setcustomerAttendance] = React.useState(null);
    const [openDialogcustomerAttendance, setOpenDialogcustomerAttendance] = React.useState(false);
    const [bulkFlag, setBulkFlag] = React.useState(false);
    const [mark, setMark] = React.useState(null);
    const [openDialogShowCommunicationHistory, setOpenDialogShowCommunicationHistory] = React.useState(false);
    const [openDialogDownloadReports, setOpenDialogDownloadReports] = React.useState(false);
    const [communcationHistoryDetails, setCommuncationHistoryDetails] = React.useState();

    const [confirmAppointment, setConfirmAppointment] = React.useState(null);
    const [openDialogConfirmAppointment, setOpenDialogConfirmAppointment] = React.useState(false);
    const [dateTimeFirst, setDateTimeFirst] = React.useState("");
    const [dateTimeSecond, setDateTimeSecond] = React.useState("");
    const [unActionableRows, setUnActionableRows] = React.useState(0);
    const [action, setAction] = React.useState();
    const [sLAFilter, setSLAFilter] = React.useState(getInitialData('sla'));

    const [searchAppointment, setSearchAppointment ] =React.useState(props.searchAppointment);

    console.log("rows", rows)
    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            console.log("here", location.pathname)
            cleverTap(
                location.pathname.includes("confirmed") ? CLEVER_TAP_EVENTS.confirmedApptVisited : CLEVER_TAP_EVENTS.newApptVisited, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                Status: !location.pathname.includes("confirmed") ? "New Appointment/ Rescheduled by Ops" : "Confirmed by Medical Center/ Confirmed by Ops",
            })
        }
        return () => { isMounted = false };
    }, [location.pathname])

    const BulkConfirmAppointments = () => {
        setOpenDialogConfirmAppointment(true);
        setBulkFlag(true);
        cleverTap(CLEVER_TAP_EVENTS.bulkConfirmBtnClick, {
            RequestIds: selected.map(ele => ele.requestId),
            srcType: "web/mWeb",
            srcPage: location.pathname,
            requestsCount: selected.length
        })
    }

    const handleClickOpenConfirmAppointment = (event, rowDetail, action) => {
        setBulkFlag(false)
        console.log("rowDetail", rowDetail)
        setConfirmAppointment(rowDetail)
        setOpenDialogConfirmAppointment(true);
        setAction(action);
        if (action === "confirm") {
            cleverTap(CLEVER_TAP_EVENTS.confirmBtnClick, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                statusInfo: "New Appointment/ Rescheduled by Ops",
                requestID: rowDetail.requestId,
                costType: rowDetail.additionalInformation.isPaid ? "Paid" : "Unpaid",
                visitType: rowDetail.additionalInformation.visitType,
                testCategory: rowDetail.additionalInformation.productName
            })
        }
    }


    const handleClickCloseConfirmAppointment = () => {
        setBulkFlag(false)
        setOpenDialogConfirmAppointment(false);
    }


    const handleClickOpenShowCommunicationHistory = (event, rowDetail) => {
        setCommuncationHistoryDetails(rowDetail)
        setOpenDialogShowCommunicationHistory(true);
    }


    const handleClickCloseShowCommunicationHistory = () => {
        setOpenDialogShowCommunicationHistory(false);
    }

    const handleClickCloseDownloadReports = () => {
        setOpenDialogDownloadReports(false);
    }

    const BulkcustomerAttendances = () => {
        setOpenDialogcustomerAttendance(true);
        setMark(true);
        setBulkFlag(true);
        cleverTap(CLEVER_TAP_EVENTS.bulkMarkAttendedBtnClick, {
            srcType: "web/mWeb",
            srcPage: location.pathname,
            statusInfo: "Customer awaited at DC",
            requestsCount: selected.length
        })
    }

    const handleClickOpencustomerAttendance = (event, rowDetail, mark) => {
        setBulkFlag(false)
        setMark(mark);
        console.log("rowDetail", rowDetail)
        setcustomerAttendance(rowDetail)
        setOpenDialogcustomerAttendance(true);
        if (mark)
            cleverTap(CLEVER_TAP_EVENTS.markAttendedBtnClick, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                statusInfo: "Customer awaited at DC",
                requestID: rowDetail.requestId,
                costType: rowDetail.additionalInformation.isPaid ? "Paid" : "Unpaid",
                visitType: rowDetail.additionalInformation.visitType,
                testCategory: rowDetail.additionalInformation.productName
            })
        else
            cleverTap(CLEVER_TAP_EVENTS.markNotAttendedBtnClick, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                statusInfo: "Customer awaited at DC",
                requestID: rowDetail.requestId,
                costType: rowDetail.additionalInformation.isPaid ? "Paid" : "Unpaid",
                visitType: rowDetail.additionalInformation.visitType,
                testCategory: rowDetail.additionalInformation.productName
            })
    }


    const handleClickClosecustomerAttendance = () => {
        setBulkFlag(false)
        setOpenDialogcustomerAttendance(false);
    }
    const RefreshAppointmentsConfirmAppointment = (value) => {
        if (value === "REFRESH") {
            props.refreshData();
        }
        setBulkFlag(false)
        setOpenDialogConfirmAppointment(false);
    }

    const RefreshAppointments = (value) => {
        if (value === "REFRESH") {
            props.refreshData();
        }
        setBulkFlag(false)
        setOpenDialogcustomerAttendance(false);
    }

    useEffect(() => {
        let isMounted = true;
        let nonActionables = 0;
        if (isMounted) {
            if (props.rows !== rows) {
                setSelected([])
                props.rows && props.rows.map((ele) => {
                    if (![STATUS_CODE_MAP['New Appointment Request'], STATUS_CODE_MAP["Customer awaited at DC"]].includes(ele.rowData.currentStatusId)) nonActionables++;
                    return null;
                });
                setUnActionableRows(nonActionables);
                setRows(props.rows);
            }

            if (props.pageNo !== page) {
                setPage(props.pageNo);
            }

            if (props.status !== status) {
                let data = JSON.parse(localStorage.getItem('pageTracking'));
                setSelected([]);
                setDateTimeFirst(data.startTime || "");
                setDateTimeSecond(data.endTime || "");
                setSLAFilter(data.sla ? data.sla : false);
                setStatus(props.status);
            }

            if (props.totalRows !== totalRows) {
                setTotalRows(props.totalRows);
            }

            if (props.searchAppointment !== searchAppointment) {
                setSearchAppointment(props.searchAppointment);
            }
        }
        return () => { isMounted = false };
    }, [props.rows, rows, props.pageNo, page, props.status, status, props.totalRows, totalRows, props.searchAppointment, searchAppointment]);



    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked && rows.length > selected.length + unActionableRows) {
            let arr = [];
            rows.map((n) => {
                if (n.rowData.currentStatusId === STATUS_CODE_MAP["Customer awaited at DC"] && status === 'confirmed') arr.push(n.rowData);
                if (n.rowData.currentStatusId !== STATUS_CODE_MAP["Not Attended"] && status !== "confirmed") arr.push(n.rowData)
                return null;
            })
            setSelected(arr);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, rowData) => {
        const selectedIndex = selected.indexOf(rowData);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, rowData);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        console.log("selectedIndex", selectedIndex);
        console.log("newSelected", newSelected);

        setSelected(newSelected);
    };

    const redirectToHistory = (event, name) => {
        history.push("/" + localStorage.getItem("roleName") + "/appointments/" + name + "/history")
    };

    const handleChangePage = (event, newPage) => {
        props.onChangePage(newPage)
        setPage(newPage);
    };


    const isSelected = (name) => selected.indexOf(name) !== -1;


    const requestSearchFirst = (event) => {
        let firstDate = "";
        if (event.target.value === "") {
            firstDate = "";
            props.onChangeStartDate(null)
            setDateTimeFirst("");
        } else {
            firstDate = new Date(event.target.value);
            let year = firstDate.getFullYear();
            let month = firstDate.getMonth() + 1;
            let day = firstDate.getDate();
            if (month < 10) {
                month = '0' + month.toString()
            }
            if (day < 10) {
                day = '0' + day.toString()
            }
            let date = year.toString() + "-" + month.toString() + "-" + day.toString();
            setDateTimeFirst(date);
            props.onChangeStartDate(firstDate)
        }
    };

    const requestSearchSecond = (event) => {
        let second = "";
        if (event.target.value === "") {
            second = "";
            props.onChangeEndDate(null)
            setDateTimeSecond("");
        } else {
            second = new Date(event.target.value);
            let year = second.getFullYear();
            let month = second.getMonth() + 1;
            let day = second.getDate();
            if (month < 10) {
                month = '0' + month.toString()
            }
            if (day < 10) {
                day = '0' + day.toString()
            }
            let date = year.toString() + "-" + month.toString() + "-" + day.toString();
            setDateTimeSecond(date);
            props.onChangeEndDate(second)
        }
    }


    const seachDateClicked = () => {
        let data = JSON.parse(localStorage.getItem('pageTracking'));
        data.startTime = dateTimeFirst;
        data.endTime = dateTimeSecond;
        localStorage.setItem('pageTracking', JSON.stringify(data))
        props.onDateSearch(true)
    }

    const exportDataHandler = () => {
        exportData(searchAppointment, page - 1, dateTimeFirst, dateTimeSecond, (dateTimeFirst || dateTimeSecond) ? "RequestFulfillmentDate" : "NA", true);
    }

    return (
        <Box className="pb-4" sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                <HeaderTags history={history} page={page} location={location.pathname}></HeaderTags>

                <div className="flex w-full justify-between pb-4 px-4">
                    <div className="flex date-filter-dashboard">
                        <div>
                            <TextField
                                className="w-full"
                                id="date"
                                label="Starting Date"
                                type="date"
                                value={dateTimeFirst ? dateTimeFirst : ''}
                                onChange={requestSearchFirst}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                        <div className="ml-2">
                            <TextField
                                className="w-full"
                                id="date"
                                label="Ending Date"
                                type="date"
                                value={dateTimeSecond ? dateTimeSecond : ''}
                                onChange={requestSearchSecond}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                        <div className="ml-2 search-icon">
                            <div className="w-full">
                                <div className="m-auto">
                                    <SearchIcon onClick={seachDateClicked} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        rows.length > 0 ?
                            <div className="flex">
                                {
                                    isInsurerAdmin() &&
                                    <div className="border border-green-400 hover:bg-green-600 hover:border-green-600 hover:text-gray-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto flex" onClick={() => setOpenDialogDownloadReports(true)}>
                                        <div className="px-1 font-svg-xxs">
                                            <ArrowCircleDownIcon></ArrowCircleDownIcon>
                                        </div>
                                        <div style={{ paddingTop: '1px' }}>
                                            Download Reports
                                        </div>

                                    </div>
                                }

                                <div className="border border-blue-400  hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto" onClick={() => exportDataHandler()}>
                                    Export
                                    <span className="pl-1 font-svg-xxs">
                                        <DownloadIcon></DownloadIcon>
                                    </span>
                                </div>
                            </div>
                            :
                            <></>
                    }

                </div>


                <TableContainer>
                    {loading ? <LinearProgress /> : ''}
                    <Table
                        sx={{ minWidth: 750 }}
                        className="text-sm"
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {/* if you don't need to support IE11, you can replace the `stableSort` call with:
         rows.slice().sort(getComparator(order, orderBy)) */}
                            {rows.length > 0 ? stableSort(rows, getComparator(order, orderBy))
                                .slice(0 * rowsPerPage, 0 * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row.rowData);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            // role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row.requestid}
                                            selected={isItemSelected}
                                        >
                                            {/* <TableCell padding="checkbox">
                                                <Checkbox
                                                    color="primary"
                                                    onClick={(event) => handleClick(event, row.rowData)}
                                                    checked={isItemSelected}
                                                    disabled={(row.rowData.currentStatusId !==  STATUS_CODE_MAP["Not Attended"] ? false : true) || (row.rowData.currentStatusId!==STATUS_CODE_MAP["Customer awaited at DC"] && status === 'confirmed' ) }
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                />
                                            </TableCell> */}
                                            <TableCell
                                                align="left"
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                className="cursor-pointer"
                                            >
                                                <div className="text-blue-600 font-semibold">
                                                    <span className='mr-1' onClick={(event) => redirectToHistory(event, row.requestid)}>{row.requestid}</span>
                                                </div>

                                                <div className="text-gray-500 text-xs">
                                                    {row.employeeId}
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                align="left">
                                                {row.customername}
                                                <div className="text-gray-500 text-xs">
                                                    {row.corporatename}
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                align="left">
                                                <div className="text-sm">
                                                    {row.employeeMailID}
                                                </div>
                                                <div className="text-gray-500 text-xs">
                                                    {row.contactNo}
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                align="left">
                                                {
                                                    row.appointmentdetails &&
                                                    <div className={(row.rowData.currentStatusId === 33) ? "bg-red-300 text-gray-900 rounded p-2 text-center w-auto text-xs font-semibold" : "bg-gray-300 text-gray-900 rounded p-2 text-center w-auto text-xs font-semibold"}>
                                                        {
                                                            row.rowData.currentStatusId === STATUS_CODE_MAP['Information Awaited'] ? "Reports Rejected" : row.rowData.currentStatusId === STATUS_CODE_MAP['Rescheduled by Ops'] ? "New Appointment Request" : row.appointmentdetails
                                                        }
                                                    </div>
                                                }
                                            </TableCell>
                                            <TableCell
                                                align="left">
                                                <div className="text-xs">
                                                    {row.packagedetails}
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                align="left">
                                                <div className="text-xs">
                                                    {row.appointmentdate}
                                                    <div className="text-gray-500 text-xs">
                                                        {row.appointmentdatetime}
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                align="left">
                                                <div className="text-xs">
                                                    {row.createdDate}
                                                    <div className="text-gray-500 text-xs">
                                                        {row.createdDateTime}
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                align="right">
                                                <div className="text-xs flex justify-end justify-items-end space-x-1">
                                                    <div className="text-red-500">
                                                        {row.additionals && row.additionals.DNDCustomer &&  !["False","false","FALSE"].includes(row.additionals.DNDCustomer) ?
                                                            <DoNotDisturbIcon />
                                                            :
                                                            row.additionals && row.additionals.DND &&  !["False","false","FALSE"].includes(row.additionals.DND) ?
                                                            <DoNotDisturbIcon /> : ''
                                                        }
                                                    </div>
                                                    <div className="text-gray-500">
                                                        {row.visitType === 'Home_Visit' ? <HomeIcon /> : ''}
                                                    </div>
                                                    <div>
                                                        {row.isHNI ? <div className="bg-yellow-100 rounded text-xs px-2 py-1"> HNI </div> : ''}
                                                    </div>
                                                    <div className="text-gray-500 text-gray-600">
                                                        <Tooltip title="Communication History" placement="bottom-end">
                                                            <TextsmsIcon onClick={(event) => handleClickOpenShowCommunicationHistory(event, row.rowData)} />
                                                        </Tooltip>
                                                    </div>

                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                }) : null}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Stack spacing={2} className="p-2">
                    <div className="flex justify-between">

                        <div className="pt-2">
                            {
                                rows.length > 0 &&
                                <div>
                                    <span className="text-gray-400 text-sm">
                                        Total Counts :
                                    </span>
                                    <span className="text-gray-400 pl-2 font-semibold text-sm">
                                        {totalRows}
                                    </span>
                                </div>
                            }
                        </div>

                        <div>
                            <Pagination count={parseInt(totalRows / 10) + 1} boundaryCount={4} showFirstButton={true} showLastButton={true} page={page} onChange={handleChangePage} />
                        </div>
                    </div>
                </Stack>
            </Paper>

            <Dialog
                open={openDialogShowCommunicationHistory}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleClickCloseShowCommunicationHistory()
                    } else return false;
                }}
                fullWidth={true}
                maxWidth={'md'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle style={{ background: "rgb(245 245 245)" }}>
                    <div className="flex justify-between">
                        <div className="font-semibold">
                            <span className="cursor-pointer">
                                Communication History
                            </span>
                            {
                                communcationHistoryDetails ?
                                    <div className="text-xs text-gray-500">
                                        Request ID <span className="font-semibold">{communcationHistoryDetails.customerDetails.requestID} </span>
                                    </div> : <></>
                            }

                        </div>
                        <div className="text-gray-500" onClick={handleClickCloseShowCommunicationHistory}>
                            <span className="cursor-pointer">
                                <CloseIcon></CloseIcon>
                            </span>
                        </div>
                    </div>

                </DialogTitle>
                <DialogContent>
                    <ShowCommunicationHistory details={communcationHistoryDetails} closeDialog={(event) => handleClickCloseShowCommunicationHistory(event)}></ShowCommunicationHistory>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openDialogDownloadReports}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleClickCloseDownloadReports()
                    } else return false;
                }}
                fullWidth={true}
                maxWidth={'sm'}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle style={{ background: "rgb(245 245 245)" }}>
                    <div className="flex justify-between">
                        <div className="font-semibold">
                            <span className="cursor-pointer">
                                Download Reports
                            </span>
                        </div>
                        <div className="text-gray-500" onClick={handleClickCloseDownloadReports}>
                            <span className="cursor-pointer">
                                <CloseIcon></CloseIcon>
                            </span>
                        </div>
                    </div>

                </DialogTitle>
                <DialogContent>
                    <DownloadReports closeDialog={(event) => handleClickCloseDownloadReports(event)}></DownloadReports>
                </DialogContent>
            </Dialog>

        </Box>
    );
}

